export default __webpack_public_path__ + "static/media/1-large.81526bc5.webp";